import React from 'react';
import { NavLink} from 'react-router-dom';
// import PerfectScrollbar from 'react-perfect-scrollbar'

const RightSidebar = ({ open = true, navigationList }) => {
  if (!navigationList || navigationList.length === 0) return null;

  const customStyle = {
    position : "absolute"
  }

  const customPaddingStyle = {
    paddingTop : "0.1em",
    paddingBottom : "0.3em"
  }

  return (
    
      <div className={'side-nav-container' + (open ? ' open' : '')} style={customStyle}>      
      {/* <PerfectScrollbar> */}
        <div className={'side-nav' + (open ? ' open' : '')}>        
          <ul style={customPaddingStyle}>
            {navigationList.map((list, index) => (
              <li key={index} style={customPaddingStyle}>
                <ul>
                  <li className="group">{list.title}</li>
                  {list.items.map((item, innerIndex) => (
                    <li key={innerIndex}>
                      <NavLink to={item.url} activeClassName="selected">
                        {item.text} 
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>          
        </div>
        {/* </PerfectScrollbar> */}
      </div>
    
  );
}

export default RightSidebar;